<template>
    <div class="sidebar-menu-container">
        <div class="sidebar-main-label">Редактировать дизайн</div>
        <div class="design-name-input-grid" v-if="version !== 'lite'">
            <div>
                <div class="ap-modal-input-name">
                    Название дизайна
                </div>
                <input type="text" class="cd-modal-text-input" v-model="designName" v-on:input="nameIsChanged()">
            </div>
            <div class="gl-square-btn btn-red design-name-button" v-on:click="saveDesignName()" v-if="nameNotSaved" title="Сохранить название">
                <SVGChecked2 class="svg-14"/>
            </div>
            <div class="gl-square-btn btn-disabled design-name-button" v-else title="Название не изменялось">
                <SVGChecked2 class="svg-14"/>
            </div>
        </div>
        <div class="sidebar-text-area">
            Выберите
            <span class="red-text bold-text">кликом в рабочей области</span>
            плоскость, материал для которой вы хотите изменить.
        </div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/select_plane.png')"/>
        </div>
    </div>
</template>

<script>
import {urlForStaticVue} from "../../common";
import SVGChecked from "../../SVG/SVGChecked";
import SVGChecked2 from "../../SVG/SVGChecked2";

export default {
    name: "SelectPlaneSidebarMenu",
    components: {SVGChecked2, SVGChecked},
    mixins: [urlForStaticVue],
    data() {
        return {
            designName: '',
            prevDesignName: '',
            nameNotSaved: false
        }
    },
    methods: {
        nameIsChanged() {
            this.nameNotSaved = true
        },
        async saveDesignName() {
            // TODO сохранение имени
            await this.$store.dispatch('active/CHANGE_ACTIVE_DESIGN_NAME', this.designName).then(()=> {
                this.prevDesignName = this.designName
                this.nameNotSaved = false
            })
        }
    },
    watch: {
        designName() {
            if (this.designName === this.prevDesignName) {
                this.nameNotSaved = false
            }
        }
    },
    computed: {
        selectedDesign() {
            console.log('project', this.$store.getters['active/DATA_ACTIVE_PROJECT'])
            return this.$store.getters['active/DESIGN'];
        },
        version() {
            return this.$route.meta.applicationVersion
        }
    },
    mounted() {
        this.designName = this.selectedDesign.designName
        this.prevDesignName = this.selectedDesign.designName
    }
}
</script>

<style scoped>
.design-name-input-grid {
    display: grid;
    grid-template-columns: auto max-content;
    grid-column-gap: 10px;
    margin-bottom: 20px;
}

.design-name-input {

}

.design-name-button{
    padding: 5px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 23px;
}

.svg-14 {
    width: 16px;
    height: 16px;
}

</style>
